import { FontWeights, mergeStyles } from "@fluentui/react";

//#region Register Email Error

export const imageContainerClassName = mergeStyles([{
    width: '50%'
}]);

export const messageContainerStyles = mergeStyles([{
    width: '50%',
    padding: '1rem'
}]);


export const iconStyles = mergeStyles([{
    color: '#CCCCCC',
    fontSize: '10rem'
}]);

export const mdlgIconStyles = mergeStyles([{
    color: '#CCCCCC',
    fontSize: '8rem'
}]);

export const smIconStyles = mergeStyles([{
    color: '#CCCCCC',
    fontSize: '6rem'
}]);


export const textStyles = mergeStyles([{
    fontFamily: 'Nunito',
    FontWeight: 700,
    fontSize: "1.2rem",
    textAlign: 'left',
    color: '#2A7DE1'
}]);

export const mdlgTextStyles = mergeStyles([{
    fontFamily: 'Nunito',
    FontWeight: 700,
    fontSize: "1rem",
    textAlign: 'center',
    color: '#2A7DE1'
}]);

export const smTextStyles = mergeStyles([{
    fontFamily: 'Nunito',
    FontWeight: 700,
    fontSize: ".875rem",
    textAlign: 'center',
    color: '#2A7DE1'
}]);

//#endregion Register Email Error